import axios from 'axios';
import { ServiceProvider } from './ProviderUtils';
import { SurveyParticipation, Question } from './SurveyUtils';
import fileDownload from 'js-file-download';
import i18n from '@/i18n';
import moment from 'moment';

interface Document {
  id: number;
  name: string;
  description: string;
  serviceprovider: Partial<ServiceProvider>;
  surveyparticipation?: Partial<SurveyParticipation>;
  uploaddate: string;
  associations?: DocumentAssociation[] | null;
}

interface DocumentAssociation {
  surveyparticipation: Partial<SurveyParticipation>; // this is redundant with the update -> surveyparticipation, but is being left in due to time issues
  question: Partial<Question>;
}

const api = {
  list: async (params?: {
    serviceproviderid?: number;
    surveyparticipationid?: number;
  }) => {
    const resp = await axios.get<Document[]>('/file/list.php', {
      params: params,
    });
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<Document>('/file/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (document: Partial<Document>, file: any) => {
    const data = new FormData();
    data.set('document', file);
    data.set(
      'request',
      new Blob([JSON.stringify(document)], { type: 'application/json' })
    );
    const resp = await axios.post<Document>('/file/upload.php', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return resp.data;
  },

  update: async (
    documents: Partial<Document>[],
    surveyparticipation: Partial<SurveyParticipation>
  ) => {
    const resp = await axios.post<Document[]>('/file/update.php', {
      files: documents,
      surveyparticipationid: surveyparticipation?.id,
    });
    return resp.data;
  },

  remove: async (id: number) => {
    await axios.delete('/file/delete.php', {
      params: { id: id },
    });
  },

  download: async (documents: Partial<Document>[]) => {
    const resp = await axios.post<any>(
      '/file/download.php',
      {
        files: documents,
      },
      { responseType: 'blob' }
    );
    if (documents.length > 1) {
      fileDownload(
        resp.data,
        `${i18n.tc('model.document.label', 2)}_${moment().format(
          'YYYY-MM-DD'
        )}.zip`
      );
    } else if (documents.length > 0) {
      fileDownload(resp.data, documents[0].name as string);
    }
  },
};

export default {
  api,
};

export { Document, DocumentAssociation };
